import { createSelector } from 'reselect';
import { JourneyDetail } from '@fullstory/proto/fs/services/dx-objects';
import { Timestamp } from '@fullstory/proto/google/protobuf';
import { AppState } from '../../types';

export const getJourneyAccess = (state: AppState) => state.journeyMaps.access;
export const getJourneysById = (state: AppState) => state.journeyMaps.journeys;
export const getAllJourneys = (state: AppState) => state.journeyMaps.allJourneys;
export const getActiveJourneys = createSelector(getJourneysById, journeys =>
  Object.values(journeys).filter(journey => !journey?.journey?.metadata?.archived),
);
export const getJourneyMetrics = (state: AppState) => state.journeyMaps.journeyMetrics;
export const getRecentJourneys = createSelector(getJourneysById, journeys => {
  const list: JourneyDetail[] = [];
  for (const key in journeys) {
    const journey = journeys[key];
    if (journey?.lastViewed) list.push(journey);
  }
  return list.sort((a, b) => Timestamp.toMillis(b.lastViewed) - Timestamp.toMillis(a.lastViewed));
});
export const getUnnamedJourney = (state: AppState) => state.journeyMaps.unnamedJourney;
